<template>
  <div class="withdraw-record">
    <div class="filter-container">
      <span class="transTime">{{ $t('components.date') }}:</span>
      <!-- 提现时间 -->
      <el-date-picker
        v-model="search.times"
        size="small"
        class="mb-10 picker"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00','23:59:59']"
        type="daterange"
        range-separator="~"
        :start-placeholder="$t('components.start_date')"
        :end-placeholder="$t('components.end_date')"
      />
      <!--交易状态  -->
      <el-select v-model="search.disburse_status" size="small" class="search-frame status mb-10" :placeholder="$t('merchantAccount.po_trans_status')" clearable>
        <el-option
          v-for="(item,index) in withdrawTransactionStatusMap"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <!-- 查询 -->
      <el-button class="search-btn mb-10" size="small" type="primary" icon="el-icon-search" @click="getMchWithdrawInfo">{{ $t('components.search') }}</el-button>
      <!-- 明细excel下载 -->
      <el-button size="small" class="mb-24 download-btn" type="info" :disabled="downloading" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('data.withdrawal_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ compWithdrawAmount(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.amount_received')" align="center">
          <template slot-scope="scope">
            <span>{{ compArriveAmount(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('dashboard.fee')" align="center">
          <template slot-scope="scope">
            <span>{{ compFeeSplit(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bank }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank_account')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_account }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank_account_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_account_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.operator')" align="center">
          <template slot-scope="scope">
            <span>{{ compOperator(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.transaction_status')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-tag class="status-tag" :type="getWithdrawTransStyle(scope.row.disburse_status)">{{ getWithdrawTransStatusLabel(scope.row.disburse_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.create_time')" align="center" min-width="170">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>

<!--        <el-table-column :label="$t('merchantAccount.update_time')" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.update_time }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->

        <el-table-column :label="$t('merchantAccount.complete_time')" align="center" min-width="170">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.note')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.action')" align="center" width="150">
          <template slot-scope="scope">
            <div class="action-buttons">
              <!-- 状态7: 详情 + 取消提现 -->
              <template v-if="scope.row.disburse_status === 7">
                <el-button class="details-btn" type="text" size="small" @click="handleDetail(scope.row)">
                  {{ $t('components.detail') }}
                </el-button>
              </template>
              <!-- 状态8: 确认 + 取消提现 -->
              <template v-else-if="scope.row.disburse_status === 8">
                <el-button class="download-btn" type="primary" size="small" @click="handleConfirm(scope.row)">
                  {{ $t('components.confirm') }}
                </el-button>
              </template>
              <!-- 其他状态: 详情 -->
              <template v-else>
                <el-button class="details-btn" type="text" size="small" @click="handleDetail(scope.row)">
                  {{ $t('components.detail') }}
                </el-button>
              </template>
            </div>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

    <Cancel_CashOut_Modal ref="cancelCashOutModalRef" @cancel-success="onCancelSuccess" />
    <Confirm_CashOut_Modal ref="confirmCashOutModalRef" @confirm-success="onConfirmSuccess" @open-cancel-modal="handleOpenCancelModal" />
  </div>
</template>

<script>

import { fetchPageMchWithdrawInfo, fetchDownloadMchWithdraw } from '@/api/settlement/settlement'
import serviceConst from '@/const/serviceConst.json'
import { exportXlsx, filterEmptyAttr } from '@/utils/common'
import { appointDate } from '@/utils/index.js'
import { withdrawTransactionStatusMap } from '@/utils/maps'
import Cancel_CashOut_Modal from '@/views/paycools/data/components/Modal/CancelCashOutModel.vue'
import Confirm_CashOut_Modal from '@/views/paycools/data/components/Modal/ConfirmCashOutModel.vue'

export default {
  name: 'Withdraw_Record',
  components: {
    Confirm_CashOut_Modal,
    Cancel_CashOut_Modal,
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      search: {
        disburse_status: null, // 交易状态
        times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        blank: ''
      },
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    isPii() {
      return this.$store.getters.isPii
    },
    // 提现金额(本币)
    compWithdrawAmount() {
      return function(row) {
        const toDivideWithDot = this.$options.filters['toDivideWithDot']
        return toDivideWithDot(row.withdraw_amount) + ' ' + (row.withdraw_currency || '')
      }
    },
    // 到账金额
    compArriveAmount() {
      return function(row) {
        const toDivideWithDot = this.$options.filters['toDivideWithDot']
        return toDivideWithDot(row.arrive_amount) + ' ' + (row.arrive_currency || '')
      }
    },
    // 服务费
    compFeeSplit() {
      return function(row) {
        const toDivideWithDot = this.$options.filters['toDivideWithDot']
        return toDivideWithDot(row.fee_split) + ' ' + (row.fee_split_currency || '')
      }
    },
    // 操作人
    compOperator() {
      return function(row) {
        return row.operate_username || ''
      }
    },
    withdrawTransactionStatusMap() {
      return withdrawTransactionStatusMap()
    },
    getWithdrawTransStatusLabel() {
      return function(value) {
        return withdrawTransactionStatusMap(value).label
      }
    },
    getWithdrawTransStyle() {
      return function(value) {
        return withdrawTransactionStatusMap(value).type
      }
    }
  },
  created() {
    this.getMchWithdrawInfo()
  },
  methods: {
    getMchWithdrawInfo(otherParams = {}) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      // const fetchApi = this.$store.getters.isPii ? fetchPageMchWithdrawInfo : fetchMchWithdrawInfo
      const fetchApi = fetchPageMchWithdrawInfo
      fetchApi(params).then(res => {
        if (res.code === serviceConst.resCode.succ) {
          if (!res.data) {
            return
          }
          const { total = 0, list = [] } = res.data
          this.listQuery.total = total
          this.listQuery.page = params.page ? params.page : 1
          this.tableData = list
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { disburse_status, times = [] } = this.search
      let params = { start_date_time: times && times[0], end_date_time: times && times[1], disburse_status, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      this.getMchWithdrawInfo(params)
    },

    onClickDowmloadBtn() {
      const params = this.getParams()
      this.downloading = true
      params.page = 0
      // const fetchApi = this.$store.getters.isPii ? fetchDownloadMchWithdraw : fetchMchWithdrawInfoAllList
      const fetchApi = fetchDownloadMchWithdraw
      fetchApi(params).then(res => {
        if (res.code === serviceConst.resCode.succ) {
          this.$message.success('Start downloading!')
          this.handleXlsxData(res.data).then((downloadData) => {
            exportXlsx(downloadData, 'Withdraw_Record')
          })
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('data.withdrawal_amount'),
        this.$t('data.withdraw_currency'),
        this.$t('data.amount_received'),
        this.$t('data.arrive_currency'),
        this.$t('merchantAccount.bank'),
        this.$t('merchantAccount.bank_account'),
        this.$t('merchantAccount.bank_account_name'),
        this.$t('dashboard.fee'),
        this.$t('data.fee_currency'),
        this.$t('merchantAccount.operator'),
        this.$t('merchantAccount.transaction_status'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.complete_time'),
        this.$t('merchantAccount.note')
      ]]
      const toDivide100 = this.$options.filters['toDivide100']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          // 新接口数据结构，金额和币种分开两列
          rows.push([
            toDivide100(tr.withdraw_amount),
            tr.withdraw_currency || '',
            toDivide100(tr.arrive_amount),
            tr.arrive_currency || '',
            tr.bank,
            tr.bank_account,
            tr.bank_account_name,
            toDivide100(tr.fee_split),
            tr.fee_split_currency || '',
            tr.operate_username,
            this.getWithdrawTransStatusLabel(tr.disburse_status),
            tr.create_time,
            tr.transaction_return_time,
            tr.remark
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.getMchWithdrawInfo(this.listQuery)
    },
    // 获取提现记录ID，兼容新旧接口
    getWithdrawId(row) {
      // 新接口使用 withdraw_id，旧接口使用 id
      return row.withdraw_id || row.id
    },
    handleConfirm(row) {
      console.log('确认提现:', row)
      this.$refs.confirmCashOutModalRef.changModalStatus(true, row)
    },
    handleDetail(row) {
      console.log('查看详情:', row)
      this.$refs.confirmCashOutModalRef.changModalStatus(true, row)
    },
    handleCancel(row) {
      console.log('取消提现:', row)
      this.$refs.cancelCashOutModalRef.changModalStatus(true, this.getWithdrawId(row))
    },
    onCancelSuccess() {
      this.getMchWithdrawInfo()
    },
    onConfirmSuccess() {
      this.getMchWithdrawInfo()
    },
    // 从确认提现弹窗打开取消提现弹窗
    handleOpenCancelModal(withdrawId) {
      this.$refs.cancelCashOutModalRef.changModalStatus(true, withdrawId)
    }
  }
}
</script>

<style lang="scss" scoped>
.withdraw-record{
  background-color: #fff;
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Poppins-Medium';
    color: #606266;
  }
  .filter-container{
    margin-top: 14px;
    margin-bottom: 32px;
    text-align: right;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .details-btn{
    color: #3855F1;
  }
 .mb-10{
    margin-bottom: 10px;
  }
  .action-buttons{
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .status-tag {
    width: 114px;
    height: 30px;
    display: inline-flex;
    padding: 0;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 3px;
    box-sizing: border-box;
    text-align: center;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

</style>
